import { FoodTypesDto } from "@gtpl/shared-models/masters";
import { FoodType } from "../food-types.entitiy";
import { FoodTypeDTO } from "./food-types.dto";

export class FoodTypeAdapter {
    convertDtoToEntity(dtoObj: FoodTypeDTO,  isUpdate: boolean = false ): FoodType {
        try {
            const entityObj = new FoodType();
            entityObj.createdUser = dtoObj.createdUser;
            entityObj.foodType = dtoObj.foodType;
            entityObj.foodTypeCode = dtoObj.foodTypeCode;
            entityObj.hsnCode =dtoObj.hsnCode;
            entityObj.remarks = dtoObj.remarks;
            if (dtoObj.foodTypeId) {
                entityObj.foodTypeId = dtoObj.foodTypeId;
                entityObj.updatedUser = dtoObj.updatedUser;
            }
            entityObj.isActive = dtoObj.isActive;
            return entityObj;
        } catch (Error) {
            throw Error;
        }
    }

    public convertEntityToDto(employeeObject: FoodType): FoodTypeDTO {
        const foodTypeDetailsDTO= new FoodTypeDTO;
        foodTypeDetailsDTO.foodTypeId = employeeObject.foodTypeId;
        foodTypeDetailsDTO.foodType = employeeObject.foodType;
        foodTypeDetailsDTO.foodTypeCode = employeeObject.foodTypeCode;
        foodTypeDetailsDTO.hsnCode = employeeObject.hsnCode;
        foodTypeDetailsDTO.remarks = employeeObject.remarks;
        foodTypeDetailsDTO.isActive = employeeObject.isActive;
        foodTypeDetailsDTO.createdAt = employeeObject.createdAt;
        foodTypeDetailsDTO.updatedAt = employeeObject.updatedAt;
        foodTypeDetailsDTO.createdUser = employeeObject.createdUser;
        foodTypeDetailsDTO.updatedUser = employeeObject.updatedUser;
        foodTypeDetailsDTO.versionFlag = employeeObject.versionFlag;
        return foodTypeDetailsDTO;
      }
}